import React from 'react';
import NavButton from "./Nav.button.jsx";


const style = {
  info: {
    color: "red",
    display: "bloc",
    fontSize: ".7rem"
  },
  link: {
    color: "blue",
    textDecoration: "underline"
  },
};

const DisabledRecordButton = () => {
  return (
    <div>
      <NavButton
        label="Enregistrer"
        href="/record"
        disabled={true}
      />
      <span style={style.info}>
        Disponible sur Pc/Mac avec{" "}
        <a
          href="https://www.google.fr/chrome/?brand=CHBD&gclid=Cj0KCQjwsMDeBRDMARIsAKrOP7FxXxr_CEEcmiBH9uySPVqwP083nVZL6BwJovIDsJgawhl22VueJ94aApQ1EALw_wcB&gclsrc=aw.ds"
          style={style.link}
        >
          Chrome,
        </a>{" "}
        <a
          href="https://www.mozilla.org/en-US/firefox/new/?utm_source=google&utm_medium=cpc&utm_campaign=Brand-FR-EN-GGL-Exact&utm_term=telecharger%20firefox&utm_content=A144_A203_A006160&&gclid=Cj0KCQjwsMDeBRDMARIsAKrOP7Fw0dI4xkF_7zNSF-wlWuzv-rUrQqqASMBeEW_OGChl67VK87yCRzQaAsX7EALw_wcB&gclsrc=aw.ds"
          style={style.link}
        >
          Firefox
        </a>{" "}
        ou{" "}
        <a
          href="https://www.opera.com/fr"
          style={style.link}
        >
          Opera.
        </a>
      </span>
    </div>
  );
}

export default DisabledRecordButton;